import { render } from "./CustomPassword.vue?vue&type=template&id=16948a00"
import script from "./CustomPassword.vue?vue&type=script&lang=js"
export * from "./CustomPassword.vue?vue&type=script&lang=js"

import "./CustomPassword.vue?vue&type=style&index=0&id=16948a00&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__